<template>
  <v-dialog v-model="viewDialog" the-app-dialogs persistent max-width="800px">
    <v-card>
      <v-layout row no-select class="not-printable" style="background-color:#09132f">
        <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
          <v-layout align-center>
            <v-icon light x-large class="rgba(0,0,0,0.3)--text" pb-1>attach_money</v-icon>
            <span px-3>{{ $t(`View Cashier Transaction's Information`) }}</span>
          </v-layout>
        </h3>
        <v-spacer />
        <v-card-actions>
          <v-btn fab icon dark @click="$emit('hidemodal')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-layout>

      <v-card-title class="view-dialog-content grey lighten-3" id="printArea">
        <invoice-header class="only-for-print" />

        <v-layout column>
          <v-layout row wrap class="invoice-content">
            <v-flex xs12 style="text-align: center" class="only-for-print" pb-3>
              <strong>{{ $t('Cashier Transaction') }}</strong>
            </v-flex>

            <v-flex xs4 pb-3>
              <div caption no-select>{{ $t('Transaction No.') }}</div>
              <strong>{{ viewInfo.transaction_no }}</strong>
            </v-flex>

            <v-flex xs4 pb-3>
              <div caption no-select>{{ $t('Transaction Type') }}</div>
              <strong>{{ $t(viewInfo.transaction_type) }}</strong>
            </v-flex>

            <v-flex xs4 pb-3>
              <div caption no-select>{{ $t('Currency Type') }}</div>
              <strong>{{ $t(viewInfo.currency_type) }}</strong>
            </v-flex>

            <v-flex xs4 pb-3>
              <div caption no-select>{{ $t('Staff') }}</div>
              <strong>{{ viewInfo.cashier_name }}</strong>
            </v-flex>

            <v-flex xs4 pb-3>
              <div caption no-select>{{ $t('Cashier Name / Code') }}</div>
              <strong>{{ viewInfo.cashier_code }}</strong>
            </v-flex>

            <v-flex xs4 pb-3>
              <div caption no-select>{{ $t('Begin Balance') }}</div>
              <strong>{{ viewInfo.begin }}</strong>
            </v-flex>

            <v-flex xs4 pb-3>
              <div caption no-select>
                {{ $t('Balance Before Transaction') }}
              </div>
              <strong>{{ viewInfo.balance | currency }}</strong>
            </v-flex>

            <v-flex xs4 pb-3>
              <div caption no-select>{{ $t('Amount') }}</div>
              <strong>{{ viewInfo.amount | currency }}</strong>
            </v-flex>

            <v-flex xs4 pb-3>
              <div caption no-select>{{ $t('Balance After Transaction') }}</div>
              <strong>{{ viewInfo.balance_after_transaction | currency }}</strong>
            </v-flex>

            <invoice-footer
              :showSignatureSection="false"
              :accountantName="''"
              :payerRecipientName="''"
              :payerOrRecipient="''"
              class="only-for-print"
            />
          </v-layout>
        </v-layout>
      </v-card-title>

      <v-divider light />

      <v-card-actions class="grey lighten-3 not-printable">
        <v-layout justify-end>
          <v-btn outline color="primary" @click="$emit('hidemodal')">
            {{ $t('Close') }}
          </v-btn>
          <v-btn color="primary" @click="printMe()">
            <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">print</v-icon>
            {{ $t('Print') }}
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'
import ignored from 'print-this'

export default {
  name: 'view-component',

  props: {
    viewDialog: { type: Boolean, required: true }
  },

  components: {
    invoiceHeader: () => import('@/views/_partials/invoiceHeader.vue'),
    invoiceFooter: () => import('@/views/_partials/invoiceFooter.vue')
  },

  computed: {
    ...mapGetters({
      viewInfo: 'cashierTransactions/getTransactionInfo'
    })
  },

  updated() {
    document.addEventListener('keyup', e => {
      // if the "ESC" button was pressed and this dialog is shown, hide it
      if (e.keyCode === 27 && this.viewDialog) {
        this.$emit('hidemodal')
      }
    })
  },

  methods: {
    printMe() {
      helpers.doPrinting()
    }
  }
}
</script>

<style scoped>
.only-for-print {
  display: none;
}
</style>
